import { Box, Typography } from "@mui/material";
import { LocalHospital } from "@mui/icons-material";
import { ColoredLabelChip } from "../../../../components/chips/ColoredLabelChip";
import { formatDateCompact } from "../../../../utils/dateUtils";
import { BaseTimelineItem } from "./BaseTimelineItem";
import type { LogbookPrescriptionItem as LogbookPrescriptionItemType } from "../../types";

const prescriptionAccent = "#44749a";

type LogbookPrescriptionItemProps = {
	prescription: LogbookPrescriptionItemType;
	isSelected: boolean;
	onClick: () => void;
	linkUrl?: string;
};

export const LogbookPrescriptionItem = ({ prescription, isSelected, onClick, linkUrl }: LogbookPrescriptionItemProps) => {
	const serviceNames = prescription.services_prescribed
		?.map((sp: any) => sp.service?.name)
		.filter(Boolean)
		.join(", ");

	return (
		<BaseTimelineItem config={{
			accentColor: prescriptionAccent,
			icon: <LocalHospital sx={{ fontSize: 14, color: prescriptionAccent }} />,
			isSelected,
			linkUrl,
		}}>
			<Box onClick={onClick} sx={{ flex: 1, cursor: "pointer" }}>
				<Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
					<Typography variant="body2" fontWeight={600} color={prescriptionAccent}>Prescrição</Typography>
					{serviceNames && (
						<Box sx={{ transform: "scale(0.8)", transformOrigin: "left" }}>
							<ColoredLabelChip label={serviceNames} color={prescriptionAccent} />
						</Box>
					)}
				</Box>
				<Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block", fontSize: "0.65rem" }}>
					{formatDateCompact(prescription.date_created)}
				</Typography>
			</Box>
		</BaseTimelineItem>
	);
};
